module.exports = __webpack_public_path__ + "static/media/logo-2x.d7606f89.png";